var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-app-search",
      attrs: { id: "form-search-popover" }
    },
    [
      _c(
        "div",
        {
          staticClass: "studio-page-header",
          class: { "studio-page-header-long": !_vm.is_sidebar_minimized }
        },
        [
          _c("h4", { staticClass: "title-tab-experience-manager" }, [
            _vm._v("BIG DATA ENGINE")
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "custom-search",
              attrs: { slot: "beforeFilter" },
              slot: "beforeFilter"
            },
            [
              _c(
                "b-form",
                { attrs: { inline: "" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn grey btn-import-form m__r--5",
                      on: {
                        click: function($event) {
                          _vm.$refs.modalAdd.show()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-plus fa-lg" }),
                      _vm._v(" Add\n        ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      attrs: { inline: "" },
                      on: {
                        keypress: function($event) {
                          if (!("button" in $event) && $event.keyCode !== 13) {
                            return null
                          }
                          $event.preventDefault()
                          _vm.filter(_vm.filter_data)
                        }
                      }
                    },
                    [
                      _c("b-form-input", {
                        staticStyle: { width: "250px", height: "35px" },
                        attrs: { placeholder: "Search" },
                        model: {
                          value: _vm.filter_data,
                          callback: function($$v) {
                            _vm.filter_data = $$v
                          },
                          expression: "filter_data"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "studio-page-content" },
        [
          _c("h4", { staticClass: "title-tab-experience-manager" }, [
            _vm._v("DATASET GROUP")
          ]),
          _vm._v(" "),
          _vm.showContainerGroup
            ? _c(
                "b-row",
                _vm._l(_vm.listGroup, function(item, index) {
                  return _c(
                    "b-col",
                    {
                      key: index,
                      attrs: { xl: "3", lg: "4", md: "4", sm: "6" }
                    },
                    [
                      _c("div", { staticClass: "data-group-container" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex" },
                          [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/icon/joana.svg"),
                                width: "25"
                              },
                              on: {
                                click: function($event) {
                                  _vm.openDetail(item.id)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "data-group-container__label ellipsis",
                                on: {
                                  click: function($event) {
                                    _vm.openDetail(item.id)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " + _vm._s(item.name) + " "
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "data-group-container__label-small"
                                  },
                                  [
                                    _vm._v(
                                      "\n                Last edit at " +
                                        _vm._s(
                                          _vm.convertDateTime(item.updated_at)
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("i", {
                              staticClass:
                                "fa fa-ellipsis-v fa-lg data-group-container__icon-config",
                              attrs: { id: "configPopover-" + item.id },
                              on: {
                                click: function($event) {
                                  _vm.showPopoverComponent(item.id)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.popoverSelected === item.id
                              ? _c(
                                  "b-popover",
                                  {
                                    directives: [
                                      {
                                        name: "click-outside",
                                        rawName: "v-click-outside",
                                        value: _vm.hideAllPopover,
                                        expression: "hideAllPopover"
                                      }
                                    ],
                                    attrs: {
                                      target: "configPopover-" + item.id,
                                      show: _vm.showPopover,
                                      triggers: "click blur",
                                      placement: "bottom"
                                    },
                                    on: {
                                      "update:show": function($event) {
                                        _vm.showPopover = $event
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "add-automation",
                                        on: {
                                          click: function($event) {
                                            _vm.openConfig(item)
                                          }
                                        }
                                      },
                                      [_vm._v("Rename")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "add-automation",
                                        on: {
                                          click: function($event) {
                                            _vm.deleteData(item)
                                          }
                                        }
                                      },
                                      [_vm._v("Delete")]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "data-group-container__count-dataset",
                            on: {
                              click: function($event) {
                                _vm.openDetail(item.id)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.total_dataset) +
                                " "
                            ),
                            _c("small", [_vm._v("dataset")])
                          ]
                        )
                      ])
                    ]
                  )
                })
              )
            : _c(
                "b-row",
                { staticClass: "data-group-wrap-loading" },
                _vm._l(8, function(i) {
                  return _c(
                    "b-col",
                    { key: i, attrs: { xl: "3", lg: "4", md: "4", sm: "6" } },
                    [_c("div", { staticClass: "group-block" })]
                  )
                })
              )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalAdd",
          staticClass: "mod-form modal-form-ui",
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v(
              _vm._s(!_vm.isUpdate ? "CREATE" : "RENAME") + " DATASET GROUP"
            )
          ]),
          _vm._v(" "),
          _c(
            "b-form-group",
            { class: { "error-input": _vm.$v.dataset_group_name.$error } },
            [
              _c("label", { attrs: { for: "name" } }, [_vm._v(" Name ")]),
              _vm._v(" "),
              _c("j-input", {
                attrs: {
                  id: "name",
                  placeholder:
                    "Only lowercase characters and underscore '_' are allowed, ex: name_form"
                },
                model: {
                  value: _vm.$v.dataset_group_name.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.dataset_group_name, "$model", $$v)
                  },
                  expression: "$v.dataset_group_name.$model"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "float-right" },
            [
              _c(
                "b-button",
                { staticClass: "btn m__r--5", on: { click: _vm.closeModal } },
                [_vm._v("\n        Close\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                { staticClass: "btn blue", on: { click: _vm.submitData } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(!_vm.isUpdate ? "Create" : "Save") +
                      "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63431b9f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63431b9f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/joanadb/jJoanaList.vue
// module id = null
// module chunks = 